module.exports = __webpack_public_path__ + "img/3.79423705.jpg";